/** 共有トークン（SPEC §3）。localStorage に保存し、401 受信時に破棄する。 */

const KEY = 'burnlog.token';

export const getToken = (): string | null => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const setToken = (t: string): void => {
  localStorage.setItem(KEY, t);
};

export const clearToken = (): void => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* プライベートモード等で localStorage が使えなくても致命的ではない */
  }
};
